var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_36982)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M24.1184 18.7377C30.6227 15.1142 38.8329 17.4496 42.4565 23.9539",
    stroke: "#C4C4C4",
    strokeWidth: 1.64187,
    strokeLinecap: "round",
    strokeDasharray: "4.1 5.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4583 24.6151C43.431 25.1441 42.8412 25.4451 42.3968 25.157C41.9523 24.8688 41.9865 24.2076 42.4583 23.9667C42.9301 23.7259 43.4856 24.0861 43.4583 24.6151Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7076 19.8133C23.1804 19.8653 22.7947 19.3271 23.0132 18.8446C23.2317 18.3621 23.8907 18.2971 24.1993 18.7276C24.5079 19.1582 24.2347 19.7613 23.7076 19.8133Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9588 34.607C45.7173 34.0503 46.3854 33.4331 46.981 33.5259C47.5767 33.6187 48.0033 34.1633 48.2368 34.724C49.0095 36.5796 48.4179 39.0524 49.8949 40.4118C50.4141 40.8919 51.1064 41.1258 51.7745 41.3517C54.0324 42.1101 56.2902 42.8645 58.5119 43.5744C59.4255 46.0553 58.6528 49.0687 56.5921 50.6621C51.05 49.7867 46.7355 48.0198 43.3749 46.0472C40.6099 44.4216 41.2297 43.2477 41.5154 40.0488C41.6 39.1049 41.8052 38.1448 42.3325 37.3582C42.8597 36.5715 43.7532 35.9826 44.695 36.027C45.6368 36.0713 46.5464 36.8781 46.5182 37.8261C46.2888 36.7168 46.3572 35.5268 45.9588 34.607Z",
    fill: "url(#paint0_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2902 39.8306L50.2255 41.5758C50.8859 42.8098 50.42 44.3462 49.1763 45.0076L45.3274 47.0526C44.5514 46.6695 43.8184 46.2718 43.1258 45.8653C40.7516 44.4694 40.8731 43.4065 41.1358 41.1087C41.179 40.7305 41.226 40.3189 41.2664 39.8668C41.3509 38.9229 41.5562 37.9628 42.0834 37.1762C42.6107 36.3896 43.5042 35.8006 44.446 35.845C45.1942 35.8803 45.922 36.3967 46.1755 37.0829C46.143 36.8404 46.1183 36.5968 46.0939 36.3558C46.0238 35.6642 45.9558 34.9931 45.7097 34.4251C45.5809 34.1282 45.7109 33.814 45.9506 33.5996L48.9004 39.1033C49.0005 39.3623 49.1269 39.6064 49.2902 39.8306Z",
    fill: "url(#paint1_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2538 41.8486C55.017 42.4384 56.7753 43.0204 58.5115 43.5752C59.4252 46.0561 58.6524 49.0694 56.5917 50.6628C54.3055 50.3017 52.2281 49.7889 50.3405 49.1725C50.1879 48.7624 50.2438 48.2782 50.327 47.8372C50.7285 45.7061 51.6168 43.6633 52.9066 41.9095C53.0168 41.8839 53.1328 41.8637 53.2538 41.8486Z",
    fill: "url(#paint2_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M40.6262 45.5923L34.1768 33.559C33.5164 32.325 33.9823 30.7886 35.226 30.1272L39.6661 27.7682C40.9057 27.1109 42.4492 27.5746 43.1136 28.8126L49.563 40.8459C50.2233 42.0799 49.7575 43.6163 48.5138 44.2777L44.0737 46.6367C42.83 47.294 41.2865 46.8263 40.6262 45.5923Z",
    fill: "url(#paint3_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M41.3368 45.2612L34.9208 33.2279C34.2639 31.994 34.7274 30.4575 35.9646 29.7962L40.3817 27.4371C41.6149 26.7798 43.1504 27.2436 43.8113 28.4816L50.2273 40.5149C50.8842 41.7488 50.4208 43.2853 49.1835 43.9466L44.7665 46.3057C43.5292 46.963 41.9937 46.4952 41.3368 45.2612Z",
    fill: "#00A99D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M41.3368 45.2612L34.9208 33.2279C34.2639 31.994 34.7274 30.4575 35.9646 29.7962L40.3817 27.4371C41.6149 26.7798 43.1504 27.2436 43.8113 28.4816L50.2273 40.5149C50.8842 41.7488 50.4208 43.2853 49.1835 43.9466L44.7665 46.3057C43.5292 46.963 41.9937 46.4952 41.3368 45.2612Z",
    fill: "url(#paint4_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M43.6573 46.1889C42.8684 46.1889 42.1479 45.756 41.7776 45.0561L35.3697 32.9839C34.8183 31.9442 35.2087 30.6456 36.2472 30.0873L40.6586 27.7206C40.9646 27.5547 41.3107 27.4697 41.6569 27.4697C42.4458 27.4697 43.1663 27.9026 43.5366 28.6025L49.9445 40.6747C50.2102 41.1804 50.2665 41.7589 50.1015 42.3051C49.9365 42.8513 49.5702 43.3003 49.067 43.5714L44.6556 45.9381C44.3496 46.0999 44.0035 46.1889 43.6573 46.1889Z",
    fill: "#5BD3C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M43.6573 46.1889C42.8684 46.1889 42.1479 45.756 41.7776 45.0561L35.3697 32.9839C34.8183 31.9442 35.2087 30.6456 36.2472 30.0873L40.6586 27.7206C40.9646 27.5547 41.3107 27.4697 41.6569 27.4697C42.4458 27.4697 43.1663 27.9026 43.5366 28.6025L49.9445 40.6747C50.2102 41.1804 50.2665 41.7589 50.1015 42.3051C49.9365 42.8513 49.5702 43.3003 49.067 43.5714L44.6556 45.9381C44.3496 46.0999 44.0035 46.1889 43.6573 46.1889Z",
    fill: "url(#paint5_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M50.1116 41.3041C50.0714 41.1022 49.9992 40.9043 49.9029 40.7145L44.8707 31.224L39.5295 28.3809L36.243 30.1457C35.2116 30.699 34.8184 31.9953 35.3682 33.0373L35.7534 33.7642L50.0674 41.3849L50.1116 41.3041Z",
    fill: "url(#paint6_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4466 37.4285C36.1663 37.2651 36.1663 37.1306 35.8907 36.7461C35.7007 38.2359 36.5891 40.1391 38.0333 40.4899C37.8053 40.2304 37.3255 40.4082 37.2019 40.735C37.0784 41.0619 37.2114 41.4319 37.3967 41.7251C37.8338 42.4171 38.5892 42.8977 39.3968 42.9987C38.9312 42.9266 38.5844 43.5177 38.7032 43.9791C38.822 44.4404 39.221 44.7624 39.6106 45.0364C40.1474 45.4161 40.9218 45.7621 41.4111 45.3151C41.8244 44.9355 41.6914 44.2001 41.2876 43.8109C40.8838 43.4216 40.3042 43.287 39.7341 43.0707C39.7436 42.5277 39.7436 41.9606 39.5108 41.4752C39.2733 40.9898 38.7222 40.6101 38.2091 40.7687C38.6984 40.6774 38.8695 40.0334 38.7507 39.5432C38.5939 38.8896 38.1141 38.3561 37.5582 37.9908C36.9929 37.6352 36.2375 37.2507 36.4466 37.4285Z",
    fill: "url(#paint7_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.087 37.0447C36.1943 37.2186 36.2549 37.3168 36.4466 37.4285C36.2375 37.2507 36.9929 37.6352 37.5582 37.9908C38.1141 38.3561 38.5939 38.8896 38.7507 39.5432C38.8629 40.0065 38.7163 40.6072 38.2868 40.7488C38.7768 40.6486 39.2852 41.0142 39.5108 41.4752C39.7436 41.9606 39.7436 42.5277 39.7341 43.0707C39.855 43.1166 39.9763 43.1588 40.0963 43.2005C40.5421 43.3555 40.9694 43.5041 41.2876 43.8109C41.6914 44.2001 41.8244 44.9355 41.4111 45.3151C41.2386 45.4727 41.0307 45.5317 40.8102 45.5254C40.8759 45.4934 40.9385 45.4513 40.9969 45.3979C41.4103 45.0182 41.2772 44.2829 40.8734 43.8936C40.5552 43.5869 40.1279 43.4383 39.6821 43.2833C39.5621 43.2416 39.4408 43.1994 39.3199 43.1535C39.3209 43.1001 39.3217 43.0464 39.3222 42.9927C39.3385 42.9927 39.355 42.9936 39.3717 42.9954C39.3552 42.9932 39.3387 42.9908 39.3223 42.9882C39.327 42.4967 39.3059 41.9943 39.0966 41.5579C38.871 41.0969 38.3626 40.7313 37.8726 40.8316C38.3021 40.6899 38.4488 40.0892 38.3365 39.6259C38.1797 38.9723 37.6999 38.4389 37.1441 38.0736C36.5787 37.718 35.8233 37.3335 36.0324 37.5113C35.9661 37.4727 35.9155 37.4357 35.8733 37.3966C35.8586 37.1752 35.8639 36.9565 35.8907 36.7461C35.9778 36.8677 36.0374 36.9643 36.087 37.0447Z",
    fill: "url(#paint8_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9067 36.499C36.1822 36.8835 36.5376 37.1225 36.8179 37.2859C37.0358 37.413 37.1759 37.4801 37.3122 37.5454C37.4868 37.6291 37.655 37.7097 37.9725 37.9094C38.5284 38.2747 39.0082 38.8081 39.165 39.4618C39.2772 39.9251 39.1306 40.5258 38.701 40.6674C39.1911 40.5671 39.6995 40.9328 39.9251 41.3938C40.1579 41.8792 40.1579 42.4463 40.1484 42.9893C40.2693 43.0352 40.3906 43.0774 40.5106 43.1191C40.9564 43.2741 41.3837 43.4227 41.7019 43.7295C42.1057 44.1187 42.2387 44.854 41.8254 45.2337C41.6529 45.3913 41.4449 45.4503 41.2244 45.444C41.2902 45.412 41.3528 45.3698 41.4114 45.3164C41.8247 44.9367 41.6916 44.2014 41.2878 43.8121C40.9696 43.5054 40.5423 43.3568 40.0965 43.2017C39.9765 43.16 39.8552 43.1178 39.7343 43.072C39.7353 43.0186 39.7361 42.965 39.7366 42.9112C39.7529 42.9113 39.7694 42.9122 39.786 42.914C39.7695 42.9118 39.7531 42.9094 39.7367 42.9069C39.7415 42.4152 39.7203 41.9128 39.511 41.4764C39.2854 41.0154 38.777 40.6498 38.287 40.75C38.7165 40.6084 38.8632 40.0077 38.7509 39.5444C38.5941 38.8908 38.1143 38.3573 37.5585 37.9921C37.1245 37.719 36.8132 37.5784 36.6057 37.4846C36.5429 37.4562 36.4896 37.4321 36.4453 37.4099C36.2688 37.3217 36.2024 37.2185 36.08 37.0284C36.0301 36.9508 35.9708 36.8588 35.8909 36.7473C35.89 36.7547 35.8891 36.7621 35.8882 36.7696C35.8893 36.6777 35.8954 36.5873 35.9067 36.499Z",
    fill: "url(#paint9_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2296 36.8463C48.377 37.2189 48.3243 37.407 47.9777 37.4289C47.6312 37.4507 47.3172 37.3567 46.8449 37.059C46.3368 36.6265 45.8688 36.2509 45.8394 35.5264C45.8101 34.8019 46.0818 34.0903 46.7723 34.1001C47.3413 35.1316 47.6398 35.356 48.2296 36.8463Z",
    fill: "url(#paint10_linear_98_36982)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5091 36.0874C48.4967 36.4585 48.3288 36.6923 47.9579 36.7048C47.587 36.7173 47.2538 36.622 46.7569 36.3321C46.2253 35.9151 45.7349 35.5523 45.7225 34.8727C45.7102 34.193 46.0192 33.5323 46.7569 33.5573C47.3379 34.5372 48.5421 35.1534 48.5091 36.0874Z",
    fill: "url(#paint11_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3632 42.2129C56.1264 42.8027 57.8847 43.3846 59.6209 43.9395C60.5345 46.4203 59.7618 49.4337 57.7011 51.0271C55.4149 50.666 53.3375 50.1531 51.4499 49.5367C51.2973 49.1267 51.3532 48.6425 51.4363 48.2015C51.8379 46.0704 52.7262 44.0276 54.016 42.2737C54.1262 42.2481 54.2422 42.228 54.3632 42.2129Z",
    fill: "url(#paint12_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6609 44.7806C55.6609 45.1923 55.3271 45.5261 54.9154 45.5261C54.5037 45.5261 54.17 45.1923 54.17 44.7806C54.17 44.3689 54.5037 44.0352 54.9154 44.0352C55.3271 44.0352 55.6609 44.3689 55.6609 44.7806ZM57.1521 48.6734C57.1521 49.0851 56.8184 49.4189 56.4066 49.4189C55.9949 49.4189 55.6612 49.0851 55.6612 48.6734C55.6612 48.2617 55.9949 47.928 56.4066 47.928C56.8184 47.928 57.1521 48.2617 57.1521 48.6734ZM53.1761 48.6733C53.5878 48.6733 53.9216 48.3395 53.9216 47.9278C53.9216 47.5161 53.5878 47.1824 53.1761 47.1824C52.7644 47.1824 52.4307 47.5161 52.4307 47.9278C52.4307 48.3395 52.7644 48.6733 53.1761 48.6733Z",
    fill: "url(#paint13_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3558 39.9765C37.0577 39.6783 37.0935 39.1896 37.1488 38.9825C37.2731 38.4441 38.1426 38.8169 38.0598 39.3967C37.9935 39.8605 38.0322 40.3354 38.0598 40.5149C37.9494 40.4596 37.654 40.2747 37.3558 39.9765Z",
    fill: "url(#paint14_linear_98_36982)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4404 44.9457C40.1734 44.8261 40.0763 44.5008 40.0612 44.3531C40.0093 43.9737 40.6656 44.0005 40.7546 44.3964C40.8258 44.7132 40.9678 45.0112 41.03 45.1206C40.9447 45.1121 40.7074 45.0652 40.4404 44.9457Z",
    fill: "url(#paint15_linear_98_36982)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6545 42.433C38.3672 42.2598 38.2367 41.8466 38.2074 41.6617C38.1188 41.1855 38.8006 41.2793 38.9292 41.7795C39.0321 42.1796 39.2066 42.563 39.2809 42.7047C39.1919 42.6862 38.9419 42.6061 38.6545 42.433Z",
    fill: "url(#paint16_linear_98_36982)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 37.6078C11.2203 38.8078 7.98585 40.5624 2.88421 41.8266C2.18817 42.0003 1.40361 42.182 1.03749 42.8C0.719642 43.3291 0.824249 44.0036 0.961044 44.6095C1.34326 46.2857 1.89849 47.9215 2.61465 49.4805C2.93249 50.1752 3.35495 50.9184 4.07915 51.1567C4.47747 51.286 4.90797 51.2456 5.31835 51.185C12.3003 49.2128 16.3175 46.0653 19.6254 40.623C19.7099 38.8781 18.7564 37.1212 17.2517 36.2447C16.8171 35.9902 16.3223 35.7883 16.0366 35.3723C13.8003 29.7478 10.2603 30.0478 12.0003 37.6078Z",
    fill: "url(#paint17_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.674 48.0114C15.0375 46.6064 19.4401 43.603 20.8304 42.029C21.5617 41.201 22.2378 40.7019 22.2781 39.9079C22.3229 39.0618 21.9121 38.4847 21.0436 38.4109C20.175 38.3371 19.3243 38.8101 18.778 39.4696C18.2318 40.1291 17.9408 40.9492 17.7214 41.7693C17.502 42.5894 12.6069 47.0568 12.674 48.0114Z",
    fill: "#C89579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6356 36.811C14.5295 36.4581 15.2533 35.6873 15.5658 34.7583C16.5071 33.3912 16.8236 31.5454 16.345 29.9309C16.2777 29.6996 16.1907 29.4725 16.0325 29.294C15.8743 29.1155 15.633 29.0019 15.4036 29.0587C15.0358 29.1479 14.8894 29.5901 14.8024 29.9674C14.4622 31.444 14.126 32.9206 13.948 34.3973C13.5209 34.9733 13.335 35.736 13.4536 36.45C13.4813 36.6244 13.5327 36.8029 13.6593 36.9165C13.7859 37.0301 14.0113 37.0422 13.6356 36.811Z",
    fill: "#C89579"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7437 34.1631L13.4252 38.454C13.3209 39.8498 14.363 41.068 15.7498 41.1729L20.7156 41.544C20.9015 41.5581 21.0843 41.5514 21.2616 41.5259C21.446 41.3513 21.6071 41.1871 21.7405 41.0361C21.901 40.8544 22.0589 40.6885 22.2079 40.5318C22.738 39.9748 23.1568 39.5347 23.1882 38.9149C23.233 38.0688 22.8222 37.4917 21.9536 37.418C21.3615 37.3677 20.7777 37.5715 20.293 37.9153C19.9242 36.8121 19.1658 35.8358 18.1621 35.2512C18.0724 35.1986 17.9801 35.1483 17.8876 35.0979C17.5321 34.9042 17.1737 34.7088 16.9471 34.3787C16.7773 34.1303 16.7094 33.8503 16.6361 33.5186C17.4521 32.1813 17.7058 30.4571 17.2554 28.9377C17.1881 28.7065 17.1011 28.4793 16.9429 28.3008C16.7847 28.1223 16.5434 28.0087 16.314 28.0655C15.9462 28.1548 15.7998 28.5969 15.7128 28.9742C15.4693 30.031 15.2279 31.0878 15.0451 32.1445C14.6585 32.8467 14.2228 33.5211 13.7437 34.1631Z",
    fill: "url(#paint18_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0907 28.7122C25.7594 27.4532 22.1287 27.1108 20.2512 27.7182C17.1037 32.191 19.4092 36.6637 21.0796 37.7404C21.9079 37.9061 23.7798 37.7736 24.6412 35.9182C25.718 33.599 25.5523 33.1849 25.1382 32.895C24.724 32.6051 26.5048 30.2859 26.0907 28.7122Z",
    fill: "url(#paint19_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M14.1708 37.7082L15.1808 24.1018C15.285 22.706 16.4954 21.6572 17.8821 21.7621L22.848 22.1332C24.2347 22.2381 25.2768 23.4564 25.1726 24.8521L24.1626 38.4585C24.0584 39.8542 22.848 40.903 21.4612 40.7982L16.4954 40.427C15.1086 40.3222 14.0665 39.1039 14.1708 37.7082Z",
    fill: "url(#paint20_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1697 29.4574C13.4181 28.6291 13.7358 28.4083 13.9152 28.4221C15.4061 28.0576 15.8893 31.8318 15.9446 33.7645C15.3648 34.8551 12.3625 37.3337 11.6999 35.147C10.8716 32.4137 12.8723 30.4491 13.1697 29.4574Z",
    fill: "url(#paint21_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4252 37.5422L14.4428 23.9358C14.5478 22.54 15.7673 21.4912 17.1645 21.5961L22.1676 21.9672C23.5648 22.0721 24.6147 23.2903 24.5097 24.6861L23.4921 38.2925C23.3871 39.6882 22.1676 40.737 20.7705 40.6321L15.7673 40.261C14.3701 40.1602 13.3202 38.9419 13.4252 37.5422Z",
    fill: "url(#paint22_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M21.7924 40.0503C22.5244 39.7364 23.0165 39.0521 23.0816 38.2673L24.1796 24.6993C24.2731 23.5281 23.3906 22.5017 22.2072 22.4091L17.1727 22.0107C16.823 21.9825 16.4651 22.0429 16.1439 22.1797C15.4119 22.4937 14.9198 23.1779 14.8547 23.9628L13.7567 37.5307C13.712 38.0982 13.8909 38.6496 14.2651 39.0803C14.6392 39.515 15.1597 39.7766 15.7291 39.8209L20.7636 40.2194C21.1133 40.2475 21.4712 40.1872 21.7924 40.0503Z",
    fill: "url(#paint23_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9608,
    d: "M22.9057 38.8373C22.9818 38.6469 23.0273 38.4433 23.0455 38.2313L23.9048 27.6011L20.9083 22.3422L17.1666 22.0326C15.9897 21.9341 14.9583 22.8044 14.8633 23.9654L14.7965 24.778L22.8288 38.8815L22.9057 38.8373Z",
    fill: "url(#paint24_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6769 48.1409C12.556 43.7742 9.86289 40.9254 7.61048 39.4697C5.93276 40.5477 4.08665 41.3592 2.15084 41.8389L2.09563 41.8527C1.38147 42.0305 0.591992 42.2271 0.218552 42.8574C-0.013562 43.2438 -0.030359 43.7043 0.0293335 44.1628C0.957328 46.6028 2.0111 49.3867 2.64828 51.1049C2.85958 51.3275 3.1065 51.5044 3.40115 51.6013C3.81791 51.7366 4.26836 51.6943 4.69776 51.6309C7.83385 50.7451 10.3983 49.6326 12.5777 48.2009C12.6105 48.1811 12.6436 48.1612 12.6769 48.1409Z",
    fill: "url(#paint25_radial_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7629 31.9404C13.6742 32.3312 13.7551 32.509 14.1009 32.4775C14.4467 32.446 14.7426 32.305 15.1638 31.9385C15.5996 31.4333 16.0047 30.9905 15.9227 30.2701C15.8408 29.5496 15.4633 28.888 14.7824 29.0034C14.3781 30.1099 14.1175 30.3773 13.7629 31.9404Z",
    fill: "url(#paint26_linear_98_36982)",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3768 31.8181C13.6076 32.109 13.9824 32.1945 14.2879 31.9838C14.5934 31.7731 15.0924 31.2586 15.3192 30.7299C15.4982 30.0784 15.6763 29.495 15.2816 28.9415C14.887 28.388 14.2454 28.041 13.6675 28.5003C13.7839 29.6335 12.7943 31.0872 13.3768 31.8181Z",
    fill: "url(#paint27_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.751 38.5503C23.5437 38.6256 23.3277 38.635 23.1144 38.5397C22.6026 38.3093 22.4976 37.5695 22.7584 37.0729C22.964 36.6817 23.3228 36.4062 23.6973 36.1188C23.798 36.0415 23.8999 35.9633 24.0002 35.8817C23.8204 35.3692 23.642 34.8309 23.7103 34.2969C23.7794 33.7883 24.147 33.2813 24.6437 33.2223C24.1914 33.223 23.8633 32.699 23.8241 32.2238C23.7673 31.5541 24.055 30.8968 24.4677 30.3752C24.8072 29.9132 24.8072 29.996 24.8071 30.0788C24.807 30.173 24.7881 30.3272 24.7648 30.4877C24.4193 30.9797 24.1927 31.5709 24.2437 32.1721C24.2828 32.6472 24.611 33.1713 25.0633 33.1706C24.5666 33.2296 24.199 33.7366 24.1298 34.2451C24.0685 34.7251 24.2064 35.2086 24.3655 35.6737C24.3506 35.6813 24.3356 35.6888 24.3205 35.6962C24.3359 35.6892 24.3514 35.6831 24.367 35.6779C24.3844 35.7288 24.4021 35.7795 24.4198 35.83C24.3195 35.9115 24.2176 35.9897 24.1168 36.0671C23.7424 36.3545 23.3835 36.6299 23.178 37.0212C22.9171 37.5177 23.0221 38.2576 23.5339 38.488C23.6061 38.5202 23.6787 38.5405 23.751 38.5503Z",
    fill: "url(#paint28_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7114 29.4594C25.9268 29.2169 25.8849 29.089 26.0271 28.6378C26.6716 29.9944 26.4201 32.0796 25.1569 32.8627C25.2928 32.5451 25.8041 32.5647 26.0233 32.8367C26.2424 33.1088 26.2313 33.5019 26.1465 33.8382C25.9467 34.632 25.3785 35.3239 24.6425 35.6713C25.0624 35.4578 25.5761 35.9116 25.6069 36.387C25.6377 36.8624 25.3588 37.2927 25.0739 37.6743C24.682 38.2023 24.0539 38.7722 23.4497 38.4999C22.9387 38.2678 22.8361 37.5276 23.0986 37.032C23.3611 36.5363 23.87 36.2279 24.3444 35.8449C24.1662 35.3318 23.9896 34.7928 24.0597 34.2591C24.1342 33.7238 24.5397 33.1914 25.0767 33.1824C24.5832 33.248 24.2201 32.6893 24.1804 32.1864C24.1258 31.5165 24.4156 30.8602 24.8301 30.34C25.2566 29.8259 25.8546 29.2254 25.7114 29.4594Z",
    fill: "url(#paint29_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4975 32.2057C25.6662 31.8192 25.4544 31.3774 25.3275 31.2048C25.0152 30.7489 24.3417 31.4133 24.6304 31.9229C24.8615 32.3305 24.9988 32.7867 25.0386 32.9639C25.1213 32.8722 25.3287 32.5922 25.4975 32.2057Z",
    fill: "url(#paint30_linear_98_36982)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4393 37.958C24.6442 37.7493 24.6158 37.411 24.576 37.2679C24.4858 36.8958 23.8845 37.1603 23.9462 37.5614C23.9955 37.8823 23.9721 38.2116 23.9542 38.3361C24.0305 38.297 24.2343 38.1668 24.4393 37.958Z",
    fill: "url(#paint31_linear_98_36982)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1845 34.9669C25.3888 34.7009 25.3594 34.2685 25.3192 34.0857C25.2279 33.61 24.6274 33.9462 24.6902 34.4588C24.7405 34.8689 24.718 35.2895 24.7005 35.4485C24.7766 35.3989 24.9801 35.233 25.1845 34.9669Z",
    fill: "url(#paint32_linear_98_36982)",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9994 38.5302C23.7935 38.6093 23.5778 38.6226 23.3628 38.5313C22.8469 38.3104 22.7282 37.5726 22.9798 37.0714C23.1781 36.6764 23.5319 36.3943 23.9009 36.1001C24.0002 36.0209 24.1007 35.9408 24.1995 35.8574C24.0102 35.3483 23.8219 34.8134 23.8803 34.2782C23.94 33.7685 24.2982 33.2548 24.7937 33.1866C24.3415 33.1957 24.0038 32.6777 23.9558 32.2034C23.8867 31.5349 24.1621 30.8723 24.5652 30.3432C24.7426 30.1196 25.0215 29.9914 25.2718 29.9365C25.1739 30.05 25.0746 30.1691 24.9836 30.2838C24.5805 30.8129 24.3051 31.4755 24.3742 32.144C24.4222 32.6183 24.7599 33.1363 25.2121 33.1272C24.7166 33.1954 24.3584 33.7091 24.2987 34.2188C24.2462 34.6998 24.393 35.1807 24.5607 35.6428C24.546 35.6506 24.5312 35.6584 24.5163 35.666C24.5315 35.6588 24.5468 35.6525 24.5622 35.6469C24.5806 35.6975 24.5992 35.7479 24.6179 35.798C24.5191 35.8814 24.4186 35.9615 24.3193 36.0407C23.9503 36.3349 23.5965 36.617 23.3982 37.012C23.1466 37.5132 23.2653 38.251 23.7812 38.4719C23.854 38.5028 23.9269 38.5217 23.9994 38.5302Z",
    fill: "#BD8A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9816 16.5359C45.0203 16.5205 45.0555 16.5019 45.0903 16.4768C45.1819 16.4088 45.2376 16.2901 45.2113 16.1795C45.1851 16.0689 45.0648 15.9869 44.9546 16.0198C44.945 16.0237 44.9287 16.0279 44.9225 16.0349C44.9183 16.0186 44.9109 16.0059 44.9036 15.9931C44.6349 15.5175 44.2325 15.1224 43.6939 15.0485C43.2385 14.9862 42.6179 15.0325 42.0437 15.4191C41.5774 15.7334 41.0071 16.1857 40.8613 17.1836C40.7796 17.7589 41.4376 18.6865 42.1092 18.8911C42.8043 19.1041 43.6395 18.7253 44.1959 18.2606C44.7024 17.8451 44.9971 17.1913 44.9816 16.5359Z",
    fill: "url(#paint33_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_98_36982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3544 11.552C38.4772 11.712 38.2205 11.7677 38.1062 11.795C37.9952 11.8285 37.6637 11.8545 37.8181 12.0356C38.0488 12.2673 38.3487 12.4389 38.4779 12.7574C38.8779 13.7516 38.041 14.4313 37.1228 14.497C36.6905 14.5278 36.4175 14.233 36.0819 14.0099C35.9118 13.8962 35.7288 13.8186 35.5238 13.8175C35.2704 13.8169 35.0186 13.7358 34.8147 13.5834C34.6741 13.479 34.559 13.3421 34.4757 13.1866C34.3839 13.0122 34.3748 12.8783 34.3781 12.6877C34.3873 12.1932 34.6536 11.6749 35.0278 11.3626C35.3092 11.1274 35.575 11.0325 35.8771 11.0804C36.1025 11.1369 36.3142 11.2726 36.5309 11.3615C36.6367 11.3929 36.7229 11.3828 36.7241 11.2532C36.7482 11.06 36.6749 10.8597 36.7428 10.6718C36.7832 10.5091 37.0285 10.3145 37.141 10.5203C37.2212 10.6126 37.1462 11.1612 37.3601 10.9945C37.4923 10.8945 37.7395 10.4658 37.9036 10.683C37.9648 10.7636 37.9618 10.9076 37.8761 10.9998C37.8034 11.0774 37.7633 11.1878 37.7167 11.2867C37.6812 11.3855 37.8811 11.3788 37.9464 11.3998C37.9496 11.4004 37.9518 11.4009 37.955 11.4015C37.9876 11.4069 38.2505 11.4606 38.3544 11.552Z",
    fill: "url(#paint34_radial_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9362 10.8885C37.9556 10.8139 37.9433 10.7351 37.9033 10.6827C37.8997 10.6786 37.8971 10.6746 37.8935 10.6705C37.8739 10.7121 37.855 10.7562 37.8355 10.7978C37.8152 10.8541 37.8713 10.8767 37.9362 10.8885Z",
    fill: "url(#paint35_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3543 11.5511C38.2426 11.4536 38.0973 11.7092 37.9617 11.6639C37.9612 11.6661 37.9518 11.3989 37.9503 11.4009C37.9462 11.3989 37.9408 11.3978 37.9344 11.3965C37.8907 11.4299 37.878 11.4764 37.937 11.5462C38.0164 11.6258 38.1048 11.6993 38.1912 11.7724C38.311 11.7394 38.4513 11.6775 38.3543 11.5511Z",
    fill: "url(#paint36_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.844 10.7639C36.8539 10.6805 36.847 10.5972 36.8404 10.5127C36.7932 10.5579 36.7557 10.6165 36.7426 10.6708C36.7174 10.7409 36.712 10.8127 36.7141 10.886C36.7888 10.894 36.8426 10.8661 36.844 10.7639Z",
    fill: "url(#paint37_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1282 13.3644C36.7189 13.5102 36.6118 13.5913 36.2022 13.5196C36.0008 13.4839 35.8491 13.3283 35.6441 13.3272C35.3907 13.3266 35.1389 13.2455 34.935 13.0931C34.7944 12.9887 34.6793 12.8518 34.596 12.6963C34.5031 12.5217 34.4938 12.3889 34.4982 12.1985C34.4983 12.1644 34.5008 12.1296 34.5043 12.095C34.4278 12.2869 34.3819 12.4884 34.3781 12.6869C34.3747 12.8775 34.3839 13.0114 34.4759 13.1846C34.5581 13.34 34.6743 13.477 34.8149 13.5814C35.0188 13.7338 35.2696 13.8147 35.524 13.8155C35.729 13.8166 35.912 13.8942 36.0821 14.008C36.4177 14.231 36.6907 14.5259 37.123 14.4951C37.8796 14.4414 38.5805 13.9702 38.5798 13.2505C37.7007 13.1373 37.5991 13.1967 37.1282 13.3644Z",
    fill: "url(#paint38_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3703 12.0136C37.518 12.0432 37.6628 12.0482 37.7997 12.0312C37.6752 11.8628 37.991 11.8372 38.0994 11.8054C38.2148 11.7783 38.4704 11.7224 38.3477 11.5624C38.2359 11.4649 37.9441 11.41 37.9437 11.4121C37.8833 11.3887 37.6718 11.3976 37.7086 11.2979C37.7544 11.1978 37.7953 11.0887 37.868 11.011C37.9537 10.9189 37.9578 10.7751 37.8955 10.6943C37.7336 10.4775 37.4853 10.906 37.3531 11.006C37.1392 11.1727 37.2144 10.623 37.134 10.5318C37.0215 10.326 36.7762 10.5206 36.7358 10.6833C36.6692 10.8703 36.7412 11.0715 36.7171 11.2647C36.7158 11.3943 36.6297 11.4044 36.5238 11.373C36.5124 11.3684 36.501 11.3638 36.4898 11.3582C36.6279 11.6716 36.9541 11.9304 37.3703 12.0136Z",
    fill: "url(#paint39_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2015 13.6244C35.727 13.5295 35.2781 13.5536 34.9467 13.6683C35.1225 13.765 35.322 13.8162 35.5227 13.8165C35.7277 13.8177 35.9107 13.8953 36.0808 14.009C36.4164 14.2321 36.6894 14.5269 37.1217 14.4961C37.2741 14.4856 37.4233 14.4574 37.5654 14.4141C37.3664 14.0691 36.8485 13.7538 36.2015 13.6244Z",
    fill: "url(#paint40_radial_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7741 11.5577C36.8176 11.6711 36.9629 11.797 37.1588 11.8772C37.3517 11.9556 37.5401 11.9671 37.6494 11.9195C37.6059 11.806 37.4606 11.6802 37.2647 11.6C37.0731 11.5207 36.8847 11.5092 36.7741 11.5577Z",
    fill: "url(#paint41_linear_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.524 11.2708C36.6485 11.2877 36.8747 11.4297 36.8745 11.4308C36.9271 11.4539 37.0667 11.5797 37.0918 11.5107C37.1088 11.4367 37.1354 11.36 37.1241 11.2815C37.1104 11.1877 37.1794 11.1172 37.2608 11.1141C37.4792 11.1043 37.4376 11.4524 37.4791 11.5757C37.5429 11.7785 37.7621 11.4729 37.8627 11.4747C38.041 11.441 38.112 11.6749 38.0604 11.7761C38.0134 11.9045 37.8658 11.9581 37.7861 12.0651C37.7762 12.0757 37.7686 12.0855 37.7644 12.095C37.5826 12.1292 37.3524 12.1082 37.1168 12.0246C36.9588 11.968 36.8194 11.8912 36.707 11.8026C36.7975 11.765 36.6265 11.5998 36.5742 11.5302C36.5093 11.4511 36.3624 11.2772 36.524 11.2708Z",
    fill: "#5B92F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4969 11.4517C37.4908 11.3981 37.4845 11.3399 37.4702 11.2881C37.4769 11.3498 37.4813 11.4064 37.4942 11.4432C37.4946 11.4467 37.4952 11.4491 37.4969 11.4517Z",
    fill: "url(#paint42_radial_98_36982)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M37.7795 11.9628C37.5977 11.9971 37.3675 11.9761 37.1318 11.8925C36.9738 11.8359 36.838 11.7859 36.7475 11.8236C36.8387 12.0571 37.0677 12.1461 37.2246 12.2026C37.4225 12.2729 37.5269 12.2721 37.7941 12.2709C38.0185 12.2703 38.0708 12.3285 38.122 12.3137C38.1261 12.3043 37.8365 12.0756 37.8465 12.0651C37.9262 11.958 37.7838 11.9523 37.7795 11.9628Z",
    fill: "url(#paint43_linear_98_36982)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.952 12.3443C30.8345 12.3817 30.701 12.3843 30.5782 12.3736C30.4553 12.3629 30.3285 12.3162 30.2244 12.2548C30.1203 12.1933 30.0135 12.1079 29.9414 12.0064C29.8693 11.9049 29.8079 11.7901 29.7705 11.6726C29.7331 11.5551 29.7305 11.4216 29.7412 11.2988C29.7519 11.1759 29.7986 11.0491 29.8601 10.945C29.9215 10.8408 30.0083 10.7461 30.1084 10.662C30.2099 10.5899 30.3247 10.5285 30.4435 10.5031C30.4676 10.5004 30.4903 10.4858 30.4996 10.4604C30.509 10.435 30.5183 10.4097 30.5036 10.387L30.4436 10.1747C30.4209 10.0799 30.3622 9.98909 30.2834 9.93701C30.2033 9.87291 30.1139 9.83418 30.0164 9.83284L25.2113 9.61198C25.1259 9.6093 25.0551 9.62932 24.9737 9.66269C24.9043 9.69473 24.8375 9.75079 24.7961 9.81621L23.6798 11.485C23.637 11.5384 23.6197 11.6011 23.6023 11.6639C23.597 11.7253 23.5929 11.7987 23.6116 11.8575L24.2922 14.3729C24.3296 14.4904 24.4017 14.5919 24.5058 14.6533C24.61 14.7147 24.7461 14.7361 24.8636 14.6987L30.7463 13.1213C30.8638 13.0839 30.9653 13.0118 31.0267 12.9077C31.0881 12.8036 31.1095 12.6674 31.0721 12.5499L31.0334 12.4204C31.0308 12.3964 31.0161 12.3737 30.9907 12.3643C31.0001 12.339 30.976 12.3416 30.952 12.3443Z",
    fill: "#FACC0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9519 12.3443C30.8344 12.3816 30.7009 12.3843 30.5781 12.3736C30.4553 12.3629 30.3284 12.3161 30.2243 12.2547C30.1202 12.1933 30.0134 12.1078 29.9413 12.0064C29.8692 11.9049 29.8078 11.7901 29.7704 11.6726C29.7331 11.5551 29.7304 11.4216 29.7411 11.2987C29.7638 11.1746 29.7985 11.0491 29.86 10.9449C29.9214 10.8408 30.0082 10.746 30.1083 10.6619C30.2098 10.5898 30.3246 10.5284 30.4435 10.5031C30.4675 10.5004 30.4902 10.4857 30.4996 10.4604C30.5089 10.435 30.5183 10.4096 30.5036 10.3869L30.4435 10.1746C30.4208 10.0798 30.3648 10.0131 30.274 9.96234C30.1952 9.91026 30.0977 9.90891 30.003 9.9316L23.896 11.5704C23.8012 11.5931 23.7344 11.6492 23.6837 11.7399C23.6316 11.8187 23.6302 11.9162 23.6529 12.011L24.2935 14.3849C24.3309 14.5024 24.403 14.6038 24.5071 14.6653C24.6112 14.7267 24.7474 14.7481 24.8649 14.7107L30.7476 13.1333C30.8651 13.0959 30.9665 13.0238 31.028 12.9197C31.0894 12.8156 31.1108 12.6794 31.0734 12.5619L31.0347 12.4324C31.032 12.4083 31.0174 12.3857 30.992 12.3763C31 12.3389 30.976 12.3416 30.9519 12.3443Z",
    fill: "#FAA01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0745 13.6644C26.4524 13.5616 26.6767 13.1718 26.5753 12.806C26.4739 12.4401 26.0827 12.2038 25.7169 12.3052C25.339 12.408 25.1147 12.7978 25.2161 13.1636C25.3175 13.5295 25.6967 13.7672 26.0745 13.6644Z",
    fill: "#DC6E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1963 11.629C28.4447 11.565 28.5982 11.3047 28.5222 11.0577C28.4461 10.8106 28.1978 10.6557 27.9508 10.7318C27.7024 10.7959 27.5489 11.0562 27.6249 11.3032C27.689 11.5515 27.9373 11.7064 28.1963 11.629Z",
    fill: "#DC6E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7794 13.6813C27.969 13.636 28.0812 13.4411 28.0238 13.2528C27.9784 13.0632 27.7835 12.951 27.5953 13.0084C27.4057 13.0538 27.2935 13.2487 27.3509 13.437C27.3963 13.6266 27.5912 13.7387 27.7794 13.6813Z",
    fill: "#DC6E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_36982",
    x1: 48.4137,
    y1: 34.3449,
    x2: 50.0702,
    y2: 50.6621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EEBFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CCB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_98_36982",
    x1: 45.1,
    y1: 45.237,
    x2: 46.7152,
    y2: 48.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1AB8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1AB8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_98_36982",
    x1: 51.0704,
    y1: 46.2862,
    x2: 58.7087,
    y2: 48.9179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118664,
    stopColor: "#FDAB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_98_36982",
    x1: 41.8699,
    y1: 27.4697,
    x2: 41.8699,
    y2: 46.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4483F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_98_36982",
    x1: 42.5741,
    y1: 27.1387,
    x2: 42.5741,
    y2: 46.6033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B88F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BABF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_98_36982",
    x1: 42.657,
    y1: 27.4697,
    x2: 42.657,
    y2: 46.1889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADCBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_98_36982",
    x1: 42.6156,
    y1: 28.3809,
    x2: 42.6156,
    y2: 41.3849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6D0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_98_36982",
    x1: 33.0905,
    y1: 36.0421,
    x2: 44.2723,
    y2: 47.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A98B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_98_36982",
    x1: 41.8703,
    y1: 44.0764,
    x2: 34.4986,
    y2: 37.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A98B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_98_36982",
    x1: 35.8882,
    y1: 36.9632,
    x2: 42.4552,
    y2: 46.3693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D94F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D94F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_98_36982",
    x1: 47.6619,
    y1: 37.2186,
    x2: 46.5781,
    y2: 34.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5090F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5090F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_98_36982",
    x1: 47.116,
    y1: 33.5566,
    x2: 47.116,
    y2: 36.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A98B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_98_36982",
    x1: 52.1798,
    y1: 46.6505,
    x2: 59.8181,
    y2: 49.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118664,
    stopColor: "#FED865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_98_36982",
    x1: 46.0114,
    y1: 44.3665,
    x2: 56.862,
    y2: 52.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAA2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAA2F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_98_36982",
    x1: 37.5883,
    y1: 38.7217,
    x2: 37.9356,
    y2: 42.2128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B79C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_98_36982",
    x1: 40.2823,
    y1: 44.0756,
    x2: 41.3663,
    y2: 46.2514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B79C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_98_36982",
    x1: 38.4108,
    y1: 41.3373,
    x2: 39.8663,
    y2: 44.0701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B79C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_98_36982",
    x1: 18.6603,
    y1: 25.1878,
    x2: 9.24032,
    y2: 48.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C28F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C89579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_98_36982",
    x1: 16.1098,
    y1: 45.1127,
    x2: 21.3692,
    y2: 35.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B07E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_98_36982",
    x1: 22.4208,
    y1: 27.4258,
    x2: 22.4208,
    y2: 37.7928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28F73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_98_36982",
    x1: 19.6717,
    y1: 21.7549,
    x2: 19.6717,
    y2: 40.8054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5991F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3963B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_98_36982",
    x1: 14.4767,
    y1: 28.3975,
    x2: 14.4767,
    y2: 35.3825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF8C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#C89579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_98_36982",
    x1: 18.9675,
    y1: 21.5889,
    x2: 18.9675,
    y2: 40.6394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D77CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_98_36982",
    x1: 11.7604,
    y1: 35.328,
    x2: 22.9804,
    y2: 39.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BABF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3380EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_98_36982",
    x1: 14.0398,
    y1: 19.2474,
    x2: 24.7198,
    y2: 35.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC2FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_98_36982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5838 43.249) rotate(171.3) scale(11.7728 11.1497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAA2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FDB244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_98_36982",
    x1: 14.3808,
    y1: 32.2214,
    x2: 15.038,
    y2: 29.3844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5090F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5090F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_98_36982",
    x1: 13.3786,
    y1: 28.7135,
    x2: 15.2532,
    y2: 31.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD8A6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_98_36982",
    x1: 24.9238,
    y1: 30.3929,
    x2: 21.5179,
    y2: 39.1175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D94F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D94F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_98_36982",
    x1: 28.4688,
    y1: 27.0967,
    x2: 21.351,
    y2: 41.2835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8C70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_98_36982",
    x1: 24.823,
    y1: 31.1224,
    x2: 25.7741,
    y2: 34.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B79C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_98_36982",
    x1: 24.2688,
    y1: 37.0903,
    x2: 24.0538,
    y2: 39.5117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B79C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_98_36982",
    x1: 25.0115,
    y1: 33.8579,
    x2: 24.6539,
    y2: 36.9334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B79C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_98_36982",
    x1: 41.5984,
    y1: 15.741,
    x2: 44.3198,
    y2: 18.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1B44A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_98_36982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.213 10.8619) rotate(11.3097) scale(3.76914 3.82645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90B8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#7AABF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_98_36982",
    x1: 36.9868,
    y1: 14.8362,
    x2: 37.5985,
    y2: 12.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_98_36982",
    x1: 37.3941,
    y1: 14.8685,
    x2: 37.9949,
    y2: 12.2086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_98_36982",
    x1: 35.9213,
    y1: 14.5949,
    x2: 36.533,
    y2: 11.8869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_98_36982",
    x1: 36.6375,
    y1: 15.0115,
    x2: 36.4004,
    y2: 12.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#5B92F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B92F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_98_36982",
    x1: 37.6229,
    y1: 10.5643,
    x2: 37.3345,
    y2: 12.0065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F68CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558FF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_98_36982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.958 14.801) rotate(11.3097) scale(2.07024 2.10173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#5B92F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_98_36982",
    x1: 37.1573,
    y1: 11.888,
    x2: 37.3097,
    y2: 11.4775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4FA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_98_36982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6324 11.2844) rotate(11.3097) scale(1.64753 1.6726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#3F7FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3ED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_98_36982",
    x1: 35.9683,
    y1: 11.5232,
    x2: 37.8904,
    y2: 12.2036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#346AE0",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285DC7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_36982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_98_36982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.27573,
    height: 3.99688,
    fill: "white",
    transform: "translate(34.8896 10.0059) rotate(11.3097)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUse);
export default __webpack_public_path__ + "static/media/use.06d079f9ba883cf44f529c8aef44a459.svg";
export { ForwardRef as ReactComponent };